export default __webpack_public_path__ + "ec24e76339171498d545dd39af23e6ff.png";